// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  margin: 12px 0 4px 0;
}

.lightweight {
  width: 100%;
  border: none;
  background-color: #f0f0f0;
  font-size: 14px;
  height: 36px;
  padding: 8px;
  box-sizing: border-box;
}

.lightweight:disabled {
  background-color: #c8c8c8;
}

.validation-error .outline-validation-background-lay,
.validation-error .fill-validation-background-lay {
  position: absolute;
  background-color: #ffc8c8;
  z-index: -1;
}
.validation-error .outline-validation-background-lay {
  top: 10px;
  right: -5px;
  bottom: 10px;
  left: -5px;
  border-radius: 2px;
}
.validation-error .fill-validation-background-lay {
  top: 0;
  right: -16px;
  bottom: 0;
  left: -16px;
  border-radius: 2px 2px 0 0;
}

.validation-warning .outline-validation-background-lay,
.validation-warning .fill-validation-background-lay {
  position: absolute;
  background-color: #fff8a0;
  z-index: -1;
}
.validation-warning .outline-validation-background-lay {
  top: 10px;
  right: -5px;
  bottom: 10px;
  left: -5px;
  border-radius: 2px;
}
.validation-warning .fill-validation-background-lay {
  top: 0;
  right: -16px;
  bottom: 0;
  left: -16px;
  border-radius: 2px 2px 0 0;
}

.validation-notice .outline-validation-background-lay,
.validation-notice .fill-validation-background-lay {
  position: absolute;
  background-color: green;
  z-index: -1;
}
.validation-notice .outline-validation-background-lay {
  top: 10px;
  right: -5px;
  bottom: 10px;
  left: -5px;
  border-radius: 2px;
}
.validation-notice .fill-validation-background-lay {
  top: 0;
  right: -16px;
  bottom: 0;
  left: -16px;
  border-radius: 2px 2px 0 0;
}

.select-radio {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  background-color: transparent;
}
.select-radio .mat-mdc-radio-group {
  position: relative;
  display: inline-block;
  height: 100%;
  z-index: 1;
}
.select-radio-validation-lay {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #ffc8c8;
  border-radius: 4px;
  z-index: 0;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/select-control/select-control.component.scss"],"names":[],"mappings":"AAyBA;EACI,oBAAA;AAxBJ;;AA2BA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AAfI;;EAEI,kBAAA;EACA,yBAAA;EACA,WAAA;AAkBR;AAfI;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAiBR;AAdI;EACI,MAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;AAgBR;;AApCI;;EAEI,kBAAA;EACA,yBAAA;EACA,WAAA;AAuCR;AApCI;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAsCR;AAnCI;EACI,MAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;AAqCR;;AAzDI;;EAEI,kBAAA;EACA,uBAAA;EACA,WAAA;AA4DR;AAzDI;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AA2DR;AAxDI;EACI,MAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;AA0DR;;AAxBA;EACI,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AA2BJ;AA1BI;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;AA4BR;AA1BI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AA4BR","sourcesContent":["@mixin validationBackgroundLay($color) {\n    .outline-validation-background-lay,\n    .fill-validation-background-lay {\n        position: absolute;\n        background-color: #{$color};\n        z-index: -1;\n    }\n\n    .outline-validation-background-lay {\n        top: 10px;\n        right: -5px;\n        bottom: 10px;\n        left: -5px;\n        border-radius: 2px;\n    }\n\n    .fill-validation-background-lay {\n        top: 0;\n        right: -16px;\n        bottom: 0;\n        left: -16px;\n        border-radius: 2px 2px 0 0;\n    }\n}\n\np {\n    margin: 12px 0 4px 0;\n}\n\n.lightweight {\n    width: 100%;\n    border: none;\n    background-color: #f0f0f0;\n    font-size: 14px;\n    height: 36px;\n    padding: 8px;\n    box-sizing: border-box;\n}\n\n.lightweight:disabled {\n    background-color: #c8c8c8;\n}\n\n.validation-error {\n    @include validationBackgroundLay(#ffc8c8);\n}\n\n.validation-warning {\n    @include validationBackgroundLay(#fff8a0);\n}\n\n.validation-notice {\n    @include validationBackgroundLay(green);\n}\n\n.select-radio {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: 10px;\n    background-color: transparent;\n    & .mat-mdc-radio-group {\n        position: relative;\n        display: inline-block;\n        height: 100%;\n        z-index: 1;\n    }\n    &-validation-lay {\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        background-color: #ffc8c8;\n        border-radius: 4px;\n        z-index: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
